import { muiTheme } from "@/styles/theme";
import { Box, Typography } from "@mui/material";
import { HistoryCardHeader } from "@/modules/lead-page/components/lead-history/history-card-header";
import { isDate, formatDate } from "@/modules/lead-page/utils/index";
import { LeadHistoryItem } from "@/modules/lead-page/dtos/index-v2";
interface LeadHistoryCardProps {
  item: LeadHistoryItem;
}

const getDate = (date: string) => {
  const targetDate = new Date(date);
  const currentDate = new Date();

  const yearsDiff = currentDate.getFullYear() - targetDate.getFullYear();
  const monthsDiff =
    currentDate.getMonth() - targetDate.getMonth() + yearsDiff * 12;
  const daysDiff = Math.floor(
    (currentDate.getTime() - targetDate.getTime()) / (1000 * 60 * 60 * 24)
  );

  if (yearsDiff > 0) {
    return `${yearsDiff} years ago`;
  } else if (monthsDiff > 0) {
    return `${monthsDiff} months ago`;
  } else if (daysDiff === 0) {
    return "today";
  } else if (daysDiff === 1) {
    return "yesterday";
  } else {
    return `${daysDiff} days ago`;
  }
};
const formatHistoryData = (value: string | number | null) => {
  if (value === null || value === undefined) {
    return "not set";
  } else if (isDate(value.toString())) {
    return formatDate(value.toString());
  }
  return value.toString();
};
export const HistoryCard = ({ item }: LeadHistoryCardProps) => {
  return (
    <>
      <HistoryCardHeader
        whodunnit={item.actor?.name}
        updatedAt={item.createdAt}
        getDate={getDate}
      />
      {Object.entries(item).map(([key, value]) => {
        if (key === "valueChanges") {
          return Object.entries(value).map(([innerKey, innerValue]) => {
            const castedValue = innerValue as { old: string; new: string };
            return (
              <Box sx={{ marginBottom: "2px" }} key={innerKey}>
                <Box
                  sx={{
                    bgcolor:
                      muiTheme.colorSchemes.light.palette.background.blue1,
                    display: "grid",
                    gridTemplateColumns: "0.5fr 0.5fr 0.5fr",
                    gap: "16px",
                    paddingRight: "16px",
                    paddingLeft: "16px",
                    paddingTop: "4px",
                    paddingBottom: "4px",
                    minHeight: "28px",
                    borderRadius: "4px",
                    marginBottom: "4px",
                  }}
                >
                  <Typography
                    sx={{
                      ...muiTheme.typography.body_sm_med,
                      color: muiTheme.colorSchemes.light.palette.neutral[900],
                      wordBreak: "break-all",
                    }}
                  >
                    {innerKey}
                  </Typography>
                  <Typography
                    sx={{
                      ...muiTheme.typography.body_sm_reg,
                      color: muiTheme.colorSchemes.light.palette.neutral[700],
                      overflowWrap: "break-word",
                      wordBreak: "break-word",
                    }}
                  >
                    {formatHistoryData(castedValue?.old)}
                  </Typography>
                  <Typography
                    sx={{
                      ...muiTheme.typography.body_sm_reg,
                      color: muiTheme.colorSchemes.light.palette.neutral[700],
                      overflowWrap: "break-word",
                      wordBreak: "break-word",
                    }}
                  >
                    {formatHistoryData(castedValue.new)}
                  </Typography>
                </Box>
              </Box>
            );
          });
        }
      })}
    </>
  );
};
